export default __webpack_public_path__ + "static/media/rusd-gradient-purple.51319a7a.svg";